import React from 'react';
import PropTypes from 'prop-types';

import { getProp } from '../../utilities';

class AddThis extends React.Component {
  componentDidMount() {
    if (!this.refresh()) {
      setTimeout(() => {
        // keby nahodou to nebolo nacitane, skusime o sekundu neskor
        this.refresh();
      }, 1000);
    }
  }

  componentDidUpdate() {
    this.refresh();
  }

  refresh() {
    if (typeof window.addthis !== 'undefined') {
      getProp(window.addthis, 'layers.refresh', () => {})();
      return true;
    }
    return false;
  }

  render() {
    return (
      <div
        className="addthis_inline_share_toolbox"
        data-url={this.props.shareUrl}
        data-title={this.props.shareTitle}
        data-media={this.props.sharePicture}
      />
    );
  }
}

AddThis.propTypes = {
  title: PropTypes.string,
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
  sharePicture: PropTypes.string,
};

export default AddThis;



// WEBPACK FOOTER //
// ./src/ui/src/component/addThis/addThis.js